import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../src/functions/useLanguage';
import { wt } from '../i18n';
import { websitePath } from '../lib/routes';
import KodaCareLogoFull from '../../src/components/Custom Icons/KodaCareLogoFull';

export function Footer() {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const appHost = import.meta.env.VITE_APP_HOST || 'https://app.kodacare.pet';
  const t = (key: Parameters<typeof wt>[1]) => wt(language, key);

  return (
    <footer className="bg-primary-brown/10 text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-12 mb-12">
          {/* Brand */}
          <div className="w-fit text-left flex flex-col items-start">
            <KodaCareLogoFull className="h-auto w-[220px] max-w-full block" />
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-12">
            <div>
              <h4 className="text-xs font-bold tracking-widest text-primary-brown/70 uppercase mb-4">{t('footer.product')}</h4>
              <ul className="space-y-3 text-sm text-primary-brown/60">
                <li><button onClick={() => { navigate(websitePath('/')); setTimeout(() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-white transition-colors">{t('nav.features')}</button></li>
                <li><button onClick={() => { navigate(websitePath('/')); setTimeout(() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-white transition-colors">{t('nav.pricing')}</button></li>
                <li><button onClick={() => navigate(websitePath('/blog'))} className="hover:text-white transition-colors">{t('nav.blog')}</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-bold tracking-widest text-primary-brown/70 uppercase mb-4">{t('footer.account')}</h4>
              <ul className="space-y-3 text-sm text-primary-brown/60">
                <li><button onClick={() => window.location.href = `${appHost}/login`} className="hover:text-white transition-colors">{t('nav.login')}</button></li>
                <li><button onClick={() => window.location.href = `${appHost}/register`} className="hover:text-white transition-colors">{t('nav.signup')}</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-bold tracking-widest text-primary-brown/70 uppercase mb-4">{t('footer.legal')}</h4>
              <ul className="space-y-3 text-sm text-primary-brown/60">
                <li><button onClick={() => navigate(websitePath('/terms'))} className="hover:text-white transition-colors">{t('footer.terms')}</button></li>
                <li><button onClick={() => navigate(websitePath('/privacy'))} className="hover:text-white transition-colors">{t('footer.privacy')}</button></li>
                <li><button onClick={() => navigate(websitePath('/faq'))} className="hover:text-white transition-colors">{t('footer.faq')}</button></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-white/10 pt-8">
          <p className="text-primary-brown/60 text-xs leading-relaxed max-w-2xl">{t('footer.disclaimer')}</p>
          <p className="text-primary-brown/50 text-xs mt-4">© {new Date().getFullYear()} KodaCare. {t('footer.rightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
}
